export default __webpack_public_path__ + "static/media/ic_web_setting.ddb59809.png";